<script>
  import { tick, createEventDispatcher } from "svelte";
  import get from "lodash/get";
  import { tooltip } from "svelte-utilities";
  import EditIcon from "@local/assets/icons/edit.svg";
  import EditCancelIcon from "@local/assets/icons/edit-cancel.svg";

  export let item;
  export let disabled;
  export let computedPrice;
  export let path = "price_override";

  const dispatch = createEventDispatcher();

  let overriding = get(item, path) != null;
  let input;
  let localValue = setLocal(get(item, path));

  $: update(item);

  function update(item) {
    localValue = setLocal(get(item, path));
    overriding = get(item, path) != null;
  }

  function setLocal(price_override) {
    return price_override
      ? price_override.toLocaleString("en-US", { style: "currency", currency: "USD" })
      : null;
  }

  function formatLocalValue() {
    const val = get(item, path);
    localValue = val != null ? val : "";
  }

  async function addOverride() {
    overriding = true;
    await tick();
    input.focus();
  }

  function updateOverride(e) {
    if (localValue != null) {
      const number = parseFloat(localValue);
      if (isNaN(number)) {
        localValue = setLocal(get(item, path));
      } else {
        if (number !== get(item, path)) {
          const basis = {
            unit_price: number,
            unit: "item",
            fabrication_price_entries: [],
            edge_treatment_price_entries: [],
          };
          dispatch("input", { value: number, basis });
        }
        localValue = setLocal(number);
      }
    }
    if (input) {
      input.blur();
    }
  }

  function keydown(e) {
    if (e.key === "Enter") {
      updateOverride();
    }
  }

  function removeOverride() {
    localValue = null;
    overriding = false;

    if (get(item, path) != null) {
      dispatch("input", { value: null, basis: {} });
    }
  }
</script>

{#if overriding}
  {#if disabled}
    <div>{get(item, path).toLocaleString("en-US", { style: "currency", currency: "USD" })}</div>
  {:else}
    <input
      size="1"
      type="text"
      placeholder={computedPrice.toFixed(2) || "0.00"}
      bind:this={input}
      bind:value={localValue}
      on:focus={formatLocalValue}
      on:blur={updateOverride}
      on:keydown={keydown} />
    <button use:tooltip={{ text: "Remove Override" }} class="button-icon" on:click={removeOverride}>
      <EditCancelIcon />
    </button>
  {/if}
{:else}
  <div class="aligned-text">
    {#if computedPrice != null}
      {computedPrice.toLocaleString("en-US", { style: "currency", currency: "USD" })}
    {:else}
      <span class="text-red-500 font-bold">N/A</span>
    {/if}
  </div>
  {#if !disabled}
    <button use:tooltip={{ text: "Override Price" }} class="button-icon" on:click={addOverride}>
      <EditIcon />
    </button>
  {/if}
{/if}

<style>
  input {
    border: none;
    outline: none;
    min-width: 3.5rem;
    max-width: 100%;

    @apply flex-1 bg-transparent text-right;
  }

  .button-icon {
    @apply text-gray-400 p-0.5 rounded;

    &:hover {
      @apply bg-gray-200 text-black;
    }
  }

  .aligned-text {
    @apply py-0.5;
  }
</style>
